import React from 'react';
import { DropDownIcon } from './DropDownIcon';

export function AttributionIcon() {
  return (
    <DropDownIcon
      childrenRender={() => (
        <>
        <rect width="50" height="50" rx="10" fill="#D9D9D9"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M23.4364 11.4364C23.7273 11.1455 24.0182 11 24.4545 11H37.5455C38.4182 11 39 11.5818 39 12.4545V25.5455C39 25.9818 38.8545 26.2727 38.5636 26.5636L22.5636 42.5636C21.9818 43.1455 21.1091 43.1455 20.5273 42.5636L7.43636 29.4727C6.85455 28.8909 6.85455 28.0182 7.43636 27.4364L23.4364 11.4364ZM24.4545 18.2727C24.8909 18.2727 25.3273 18.5636 25.6182 18.8545L27.3636 21.4727L30.4182 22.3455C30.8545 22.4909 31.2909 22.7818 31.4364 23.3636C31.5818 23.8 31.4364 24.3818 31.1455 24.6727L29.2545 27.1455L29.4 30.2C29.4 30.6364 29.2545 31.0727 28.8182 31.3636C28.3818 31.6545 27.9455 31.6545 27.5091 31.5091L24.6 30.4909L21.6909 31.5091C21.2545 31.6545 20.6727 31.6545 20.3818 31.3636C19.9455 31.0727 19.8 30.6364 19.8 30.2L19.9455 27.1455L17.7636 24.6727C17.4727 24.2364 17.3273 23.8 17.4727 23.3636C17.6182 22.9273 18.0545 22.4909 18.4909 22.3455L21.5455 21.4727L23.2909 18.8545C23.5818 18.5636 24.0182 18.2727 24.4545 18.2727Z" fill="#343434"/>
        </>
      )}
    />
  );
}